import type { IPaymentsRoute } from '#/api/v4Service';
import { NETWORK_DISPLAY_NAMES } from '#/constants/audd';
import type { INetworkRoute } from './auddSlice';

export interface IMetaEntry {
  name: string;
  value: any;
}

export function getMeta(entries: IMetaEntry[], key: string): string {
  return entries.find((e) => e.name === key)?.value || '';
}

function parseCryptoNetworks(meta: IMetaEntry[]): any[] {
  const value = meta.find((e) => e.name === 'crypto_networks')?.value;
  if (Array.isArray(value)) return value;
  if (typeof value !== 'string') return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/**
 * Stopgap until every network has its own payment route: reads the chains listed in the fiat
 * route's `crypto_networks` meta. Every network is backed by the fiat route, so they all share
 * its fee row and PSP.
 */
export function networksFromFiatMeta(fiatRoute: IPaymentsRoute, meta: IMetaEntry[]): INetworkRoute[] {
  const validateAddress = getMeta(meta, 'validate_address') === 'on';

  return parseCryptoNetworks(meta)
    .filter((n) => n && typeof n.name === 'string' && n.name)
    .map((n) => {
      const name = n.name.toLowerCase();
      return {
        name,
        displayName: NETWORK_DISPLAY_NAMES[name] || n.display_name || name.charAt(0).toUpperCase() + name.slice(1),
        addressTagType: n.tag_type || null,
        verificationType: n.verification_type || fiatRoute.verification_type || null,
        paymentRouteId: fiatRoute.payment_route_id,
        pspServiceId: fiatRoute.psp_service_id || null,
        depositEnabled: fiatRoute.deposit_enabled === 'on',
        withdrawalEnabled: fiatRoute.withdrawal_enabled === 'on',
        validateAddress,
      };
    });
}
